export const LANGUAGE_OPTIONS = [
  { value: "en" },
  { value: "es" },
  { value: "fr" },
  { value: "ar" },
];

const MANAGED_LANGUAGE_PROVIDERS = new Set(["finitless", "whatsapp"]);

const normalizeProvider = (provider) => String(provider || "").toLowerCase();

const resolveFallbackLanguage = (fallback = "en") => {
  const normalizedFallback = String(fallback || "")
    .trim()
    .toLowerCase();
  if (normalizedFallback.startsWith("es")) {
    return "es";
  }
  if (normalizedFallback.startsWith("fr")) {
    return "fr";
  }
  if (normalizedFallback.startsWith("ar")) {
    return "ar";
  }
  if (normalizedFallback.startsWith("en")) {
    return "en";
  }
  return "en";
};

export const supportsManagedLanguage = (provider) => {
  return MANAGED_LANGUAGE_PROVIDERS.has(normalizeProvider(provider));
};

export const normalizeLanguageCode = (value, fallback = "en") => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();

  if (normalized.startsWith("es")) {
    return "es";
  }

  if (normalized.startsWith("fr")) {
    return "fr";
  }

  if (normalized.startsWith("ar")) {
    return "ar";
  }

  if (normalized.startsWith("en")) {
    return "en";
  }

  return resolveFallbackLanguage(fallback);
};

export const normalizeSettingsLanguage = (provider, settings = {}) => {
  if (!supportsManagedLanguage(provider)) {
    return { ...(settings || {}) };
  }

  const nextSettings = { ...(settings || {}) };
  nextSettings.language_code = normalizeLanguageCode(
    nextSettings.language_code,
  );

  return nextSettings;
};
